import { useState, useEffect } from 'react';
import { ds } from '../styles/designSystem';

/**
 * Devuelve true si el viewport actual es ≥ ds.bp.md (1024px).
 * Actualiza en vivo al cambiar el tamaño de la ventana.
 */
export function useIsDesktop() {
  const query = `(min-width: ${ds.bp.md}px)`;

  const getInitial = () => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  };

  const [isDesktop, setIsDesktop] = useState(getInitial);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const handler = (e) => setIsDesktop(e.matches);
    if (mql.addEventListener) mql.addEventListener('change', handler);
    else mql.addListener(handler);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler);
      else mql.removeListener(handler);
    };
  }, [query]);

  return isDesktop;
}
